import { render } from "./HospitalListItem.vue?vue&type=template&id=0fccb064"
import script from "./HospitalListItem.vue?vue&type=script&lang=js"
export * from "./HospitalListItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__